export const getBaseUrl = () => {
  switch (window.location.hostname) {
    case 'localhost':
      // Staging URL
      // return 'https://odin.stage.wheelseye.in';
      return 'http://odin.staging-we.com';
    default:
      // Current URL
      return window.location.origin;
  }
};

export const getVibheeshanBaseUrl = () => {
  switch (window.location.hostname) {
    case 'localhost':
      // Staging URL
      return 'https://trucking-web.stage.wheelseye.in';
    case 'odin.dev.wheelseye.in':
      return 'https://trucking-web.dev.wheelseye.in';
    case 'odin.stage.wheelseye.in':
      // Staging URL
      return 'https://trucking-web.stage.wheelseye.in';
    default:
      // Current URL
      return 'https://wheelseye.com';
  }
};

/** Public URL for marketplace static uploads (same host rules as trucking web; prod uses http per CDN setup) */
export const buildMarketplaceStaticImgUrl = (fileName) => {
  if (fileName == null || fileName === '') return '';
  const s = String(fileName);
  const slash = Math.max(s.lastIndexOf('/'), s.lastIndexOf('\\'));
  const name = (slash === -1 ? s : s.slice(slash + 1)).trim();
  if (!name) return '';
  let base = getVibheeshanBaseUrl().replace(/\/$/, '');
  if (base === 'https://wheelseye.com') {
    base = 'http://wheelseye.com';
  }
  return `${base}/static-content/marketplace/img/${encodeURIComponent(name)}`;
};

export const getBetaalBaseUrl = () => {
  switch (window.location.hostname) {
    case 'localhost':
      // Staging URL
      return 'http://betaal.prod-we.com';
    case 'odin.stage.wheelseye.in':
      // Staging URL
      return 'http://betaal.staging-we.com';
    case 'odin.dev.wheelseye.in':
      //Dev URl
      return 'http://betaal.dev-we.com';
    default:
      // Current URL
      return 'https://odin.wheelseye.com/betaal';
  }
};

export const BASE_URL = getBaseUrl();
export const LOCAL_BASE_URL = 'http://localhost:8080';

export const VIBHEESHAN_BASE_URL = getVibheeshanBaseUrl();

export const BETAAL_BASE_URL = getBetaalBaseUrl();

export const urls = {
  getConsigners: `${BASE_URL}/odin/v2/consigner/filter`,
  getConsignerType: `${BASE_URL}/odin/v2/consigner/type`,

  getSearchResults: `${BASE_URL}/odin/v2/consigner/search`,
  getOperatorSearch: `${BASE_URL}/odin/v2/operators/search`,
  getConsignerStatus: `${BASE_URL}/odin/v2/consigner/status`,
  uploadConsignerFile: `${BASE_URL}/odin/v2/consigner/getUploadUrl`,
  viewConsignerFile: `${BASE_URL}/odin/v2/consigner/getViewUrl`,
  getConsignerByCode: `${BASE_URL}/odin/v2/consigner/`,
  getConsignerVpa: `${BASE_URL}/odin/v2/vpa`,
  getConsignerAddress: `${BASE_URL}/address/get`,
  getConsignerGst: `${BASE_URL}/odin/v2/gst`,
  editBusinessDetail: `${BASE_URL}/odin/v2/consigner`,
  getConsignerWalletBalance: `${BASE_URL}/odin/v2/consigner/wallet`,

  saveConsignerAddress: `${BASE_URL}/address/update`,
  createConsignerAddress: `${BASE_URL}/address/create`,
  saveConsignerGst: `${BASE_URL}/odin/v2/gst`,
  createConsignerGst: `${BASE_URL}/odin/v2/consigner/pan-gst`,
  deletePoc: `${BASE_URL}/poc/delete`,
  deleteAddress: `${BASE_URL}/address/delete`,
  deleteGst: `${BASE_URL}/gst/delete`,
  uploadFile: `${BASE_URL}/consigner/uploadDoc`,
  viewFile: `${BASE_URL}/consigner/getViewUrl`,
  getUploadGstUrl: `${BASE_URL}/odin/v2/gst/getUploadGstUrl`,
  getViewGstUrl: `${BASE_URL}/odin/v2/gst/getViewGstUrl`,
  getThirdPartyList: `${BASE_URL}/bankAccount/getByOpId`,
  createBankAccount: `${BASE_URL}/odin/v2/bank-accounts`,
  editBankAccount: `${BASE_URL}/bankAccount/update`,
  disableEdit: `${BASE_URL}/bankAccount/setDisable`,
  bulkUpload: (type) => `${BASE_URL}/odin/v2/bulkUpload?type=${type}`,
  getUploadTypes: `${BASE_URL}/odin/v2/bulkUpload`,
  getFormConfig: `${BASE_URL}/odin/v2/demands/config`,
  getVehiclesByDemandId: (demandId) => `${BASE_URL}/odin/v2/demands/${demandId}/supply-vehicles`,
  getRcConfig: `${BASE_URL}/odin/v2/consignments/rc-trip-option`,
  getLaneList: `${BASE_URL}/lane/lanesByLike`,
  getConsignerList: `${BASE_URL}/odin/v2/consigner/search`,
  getAddress: `${BASE_URL}/odin/v4/address-book/search`,
  createDemand: `${BASE_URL}/odin/v4/demands`,
  addLane: `${BASE_URL}/lane/create`,
  operatorsList: `${BASE_URL}/odin/v2/operators`,
  operatorsList2: `${BASE_URL}/odin/v2/operator`,

  operators: `${BASE_URL}/odin/v2/operator`,
  operatorsV3: `${BASE_URL}/odin/v3/operator`,
  operatorBasicDetails: `${BASE_URL}/supply/operator`,
  vehicleBasicDetails: `${BASE_URL}/supply/vehicle`,
  operatorById: `${BASE_URL}/operator/getById`,
  operatorType: `${BASE_URL}/odin/v2/operators/type`,
  operatorStatus: `${BASE_URL}/odin/v2/operators/status`,
  getPhoneNo: `${BASE_URL}/odin/v3/consigner/get-number`,
  vehiclesList: `${BASE_URL}/odin/v2/vehicles/onboarding`,
  bankByOpId: `${BASE_URL}/bankAccount/getByOpId`,
  updateOperator: `${BASE_URL}/operator/update`,
  createOperator: `${BASE_URL}/operator/create`,
  settleTrip: `${BASE_URL}/demand/settleTrip`,
  sendToThirdParty: `${BASE_URL}/bankAccount/updateToThirdParty`,
  downloadLedger: `${BASE_URL}/report/download/operatorLedger`,
  uploadOperatorFile: `${BASE_URL}/odin/v2/operators/upload-url`,
  getTds: `${BASE_URL}/odin/v2/operators/tds`,
  viewOperatorFile: `${BASE_URL}/odin/v2/operators/view-url`,
  operatorInfo: `${BASE_URL}/odin/v2/operators/info`,
  postOperatorRecovery: `${BASE_URL}/odin/v1/operator-recovery`,
  sendTokenLink: `${BASE_URL}/odin/v2/demands/`,
  sendNotification: `${BASE_URL}/odin/v2/demands/`,
  consignmentStates: `${BASE_URL}/odin/v2/consignments/states`,
  getConsignments: `${BASE_URL}/odin/v2/consignments`,
  stoppageReasonUpdate: `${BASE_URL}/odin/v2/consignments/vehicle-status`,

  getTransactions: `${BASE_URL}/odin/v2/transactions`,
  getTdsInfo: `${BASE_URL}/odin/v2/demands`,
  getOperatorExpense: `${BASE_URL}/odin/v2/expenses/operator`,
  getThirdPartyExpense: `${BASE_URL}/odin/v2/expenses/third-party`,
  getShipperExpense: `${BASE_URL}/odin/v2/expenses/consigner`,
  getOperatorByPhone: `${BASE_URL}/odin/v2/operator-by-phone`,
  getComments: `${BASE_URL}/odin/v2/comments`,
  getDemands: `${BASE_URL}/odin/v2/demands`,
  getDemandsBasicDetails: `${BASE_URL}/odin/v2/consignments`,
  getDemandsOperationV4: `${BASE_URL}/odin/v4/demands`,
  getAddressV4: `${BASE_URL}/odin/v4/demands`,
  patchAddress: `${BASE_URL}/odin/v4/addresses`,
  getEmails: `${BASE_URL}/odin/v2/demands/email-list`,
  getDistricts: `${BASE_URL}/odin/v2/demands/districts`,
  selectMapLocation: `${BASE_URL}/odin/v2/map/select`,
  getOperationsAssignToEmailList: `${BASE_URL}/odin/v2/consignments/getAllOpsPoc`,

  updatePodStatusAPiUrl: `${BASE_URL}/odin/v2//consignments/update-pod-status?consignment-id=`,

  getBankAccounts: `${BASE_URL}/odin/v2/bank-accounts/search`,
  getDockets: `${BASE_URL}/odin/v2/dockets`,
  addExpense: `${BASE_URL}/odin/v2/expenses`,
  addExpenseNew: `${BASE_URL}/odin/v3/expenses`,
  verifyOtp: `${BASE_URL}/odin/maker-checker/verify-otp`,
  resendOtp: `${BASE_URL}/odin/maker-checker/resend-otp`,
  rcUpload: `${BASE_URL}/odin/v2/vehicles/upload-url`,
  rcSave: `${BASE_URL}/odin/v2/vehicles/doc-url`,
  docketApi: `${BASE_URL}/odin/v2/dockets`,
  sharePaymentLinkApi: (demandId) => `${BASE_URL}/odin/v2/demands/${demandId}/share-payment-link`,
  mapSearch: `${BASE_URL}/odin/v2/map/search`,
  // placeSelect: `${BASE_URL}/places/v1/analytics/sauron/selection`,
  placeSelect: `${BASE_URL}/places/v1/analytics/sauron/selection`,
  currentLocation: `${BASE_URL}/odin/v2/locations/current-location`,
  viaPoints: `${BASE_URL}/odin/v2/addresses/search`,
  createViaPoint: `${BASE_URL}/odin/v2/addresses/via-point`,
  operationSearchUrl: `${BASE_URL}/odin/v2/consignments/search`,
  updateLocation: `${BASE_URL}/odin/v2/locations/offline-location`,
  loadingSlip: `${BASE_URL}/report/download/loadingSlip`,
  settleShipper: `${BASE_URL}/odin/v2/invoices`,
  saveBasicDetailsUrl: (cid) => `${BASE_URL}/odin/v2/consignments/${cid}/supply-details`,
  quotations: `${BASE_URL}/odin/v2/quotations`,
  exotel: `${BASE_URL}/user/exotel`,
  getVehicles: `${BASE_URL}/odin/v2/vehicles/size`,
  updateVehicleAttr: (opCode) => `${BASE_URL}/rest/tesseract/v1/vehicle/attributeConfig?opCode=${opCode}`,
  loginV2: `${BASE_URL}/odin/user/v2/login`,
  sendOtp: `${BASE_URL}/odin/user/v2/send-otp`,
  bulkVehicleUpdate: `${BASE_URL}/odin/v2/vehicles/bulk-size`,
  consignerBillingDetails: `${BASE_URL}/odin/v2/consigner`,
  updateConsignerBillingAccount: `${BASE_URL}/odin/v3/consigner/billing-accounts`,
  updateConsignerPanGst: `${BASE_URL}/odin/v2/consigner/pan-gst`,
  consignerV2: `${BASE_URL}/odin/v2/consigner`,
  uploadPreSignedUrl: `${BASE_URL}/odin/v2/consigner/preSignedUrl/upload`,
  transactionsListUrl: `${BASE_URL}/odin/v2/consigner/wallet/transaction`,
  getCashBackType: `${BASE_URL}/odin/v2/consigner/wallet/transaction/types`,
  addNewTransactionUrl: `${BASE_URL}/odin/v2/consigner/wallet/transaction`,
  getBillingDetails: `${BASE_URL}/odin/v3/consigner/billing-accounts`,

  // getConsignments: `${BASE_URL}/odin/v2/consignments`,

  getIssueTicketFTL: `${BASE_URL}/odin/tickets/v2`,
  getIssueTicket: `${BASE_URL}/odin/v1/ticket`,

  getIssueTicketPTL: `${BASE_URL}/odin/v1/ticket`,
  getTicketsByConsignment: (code, source) =>
    `${BASE_URL}/odin/v2/consignments/tickets?consignmentCode=${code}&sources=${source}`,
  addticketPost: `${BASE_URL}/odin/v1/ticket`,
  getEmailsTicket: `${BASE_URL}/odin/v1/ticket/poc`,
  // getTicketDetailPageDetailEndPoint:`${BASE_URL}/odin/v1/ticket/`,

  // addNewComment:`${BASE_URL}/odin/v1/ticket`,

  getUtils: `${BASE_URL}/odin/util`,
  stopBookingAutomation: `${BASE_URL}/odin/v2/demands/stop-automation`,
  getPodDetails: `${BASE_URL}/odin/v2/dockets/trip-pod-details`,

  getPodHistory: `${BASE_URL}/odin/v2/consignments`,
  uploadDocumentFle: `${BASE_URL}/odin/v1/file/upload`,

  getODVTList: (opCode) => `${BASE_URL}/supply/operator/${opCode}/odvt`,
  addODVTItem: `${BASE_URL}/supply/operator/odvt`,
  updateODVTItem: (odvtId) => `${BASE_URL}/supply/operator/odvt/${odvtId}`,

  searchByVehicleNumber: (vNum) => `${BASE_URL}/supply/operator/vehicle/search?vNum=${vNum}`,

  getRateInfo: () => `${BASE_URL}/odin/v2/demands/rate-info`,
  podValidityRemark: (status) => `${BASE_URL}/odin/v2/consignments/pod-validity?status=${status}`,

  cancellationReasons: () => `${BASE_URL}/odin/v2/consignments/cancel-config`,
  cancelTrip: (cid) => `${BASE_URL}/odin/v2/consignments/${cid}/cancel`,
  tdsRecalculate: (consignmentId) => `${BASE_URL}/odin/v2/consignments/${consignmentId}/tds-recalculate`,
  statesDocket: () => `${BASE_URL}/odin/util/state-code`,
  detailsConfig: (ticketId) => `${BASE_URL}/odin/v1/ticket/${ticketId}/detail/config`,
  stoppageReasons: () => `${BASE_URL}/odin/v2/consignments/reasons?type=IN_TRANSIT_DELAY`,
  tripMapDetailsUrl: (params) => `${BASE_URL}/odin/v2/consignments/${params.consignmentId}/vehicle-path`,

  tripItinerary: (params) =>
    `${BASE_URL}/odin/v2/consignments/${params.consignmentId}/trip-itinerary?itinerary=${params.itinerary}`,
  getMaterialDetailsUrl: (params) => `${BASE_URL}/odin/v2/demands/${params.demandId}/materials`,
  getMaterialTypesRequestUrl: (params) => `${BASE_URL}/odin/v2/demands/${params.demandId}/materials`,
  createMaterialDetailsRequestUrl: (payload) => `${BASE_URL}/odin/v2/demands/${payload.id}/materials`,
  getDelayReasonsUrl: (params) =>
    `${BASE_URL}/odin/v2/consignments/reasons?type=IN_TRANSIT_DELAY&delayReason=${params?.reason}`,
  getCancelReasonsUrl: () => `${BASE_URL}/odin/v2/consignments/reasons?type=CANCEL`,
  getIssuesByUserType: (type = 'OPERATOR') => `${BASE_URL}/odin/v1/ticket/config/issue/${type}`,
  getDemandsTripsUserOptions: () => `${BASE_URL}/odin/v1/ticket/user-option`,
  getUpdateConsignerPaymentModeOptions: (params) =>
    `${BASE_URL}/odin/v3/consigner/payment-profile?consignerCode=${params?.consignerCode}`,
  getTicketingEntity: (ticketId) => `${BASE_URL}/odin/v1/ticket/${ticketId}/entity`,
  postTicketingFields: () => `${BASE_URL}/odin/v1/ticket/entity`,
  consignerBusinessDetails: (consignerCode) => `${BASE_URL}/odin/v2/consigner/business-detail/${consignerCode}`,
  getViewImage: (resKey, fileName) => `${BASE_URL}/odin/v1/file/view?doc-code=${resKey}&file-name=${fileName}`,
  updateReferenceId: `${BASE_URL}/odin/v2/consignments/part-truck`,
  createBulkDemandPTL: `${VIBHEESHAN_BASE_URL}/rest/vibheeshan/bulk-upload/demands`,
  ptlBulkMIS: (tpt) => `${VIBHEESHAN_BASE_URL}/rest/vibheeshan/bulk-upload/${tpt}/demand-locations`,
  ptlBulkMISTransporters: `${VIBHEESHAN_BASE_URL}/rest/vibheeshan/transporter`,
  ptlFreightUpload: `${VIBHEESHAN_BASE_URL}/rest/vibheeshan/bulk-upload/freight-or-other`,
  getCommentsList: (ticketId) => `${BASE_URL}/odin/v1/ticket/${ticketId}/ticketConfig`,
  getPaymentBillingData: (demandId) => `${BASE_URL}/odin/v4/demands/billing?demandId=${demandId}`,
  getLaneRateList: `${BETAAL_BASE_URL}/django-api/wfms-operator-odvt-rate-input`,
  getPtlMetaDataRequestUrl: (demandId) => `${VIBHEESHAN_BASE_URL}/rest/vibheeshan/demands/${demandId}/special-requests`,
  postConfirmation: (code) => `${BASE_URL}/odin/v3/consigner/extension/${code}`,
  getGstDetails: (demandId) => `${BASE_URL}/odin/v2/demands/${demandId}/demand-billing-details`,
  submitDocketImage: (consignmentId) => `${BASE_URL}/odin/v2/dockets/${consignmentId}/picture-proof`,
  getImageProofDocketDetails: (params) =>
    `${BASE_URL}/odin/v2/dockets/picture-proof?consignment-id=${params.consignmentId}&vehicle-status=${params.vehicleStatus}`,
  submitDelayModal: (id) => `${BASE_URL}/odin/v2/consignments/${id}/delay-details`,
  getDelayModal: (id) => `${BASE_URL}/odin/v2/consignments/${id}/delay-details`,
  generateEwayBillNumber: (ewayBillNumber, consignmentId) =>
    // /odin/v2/consignments/ewaybill/trigger?ewayNumber=&consignmentId=2059819'
    `${BASE_URL}/odin/v2/consignments/ewaybill/trigger?ewayNumber=${ewayBillNumber}&consignmentId=${consignmentId}`,
  checkBiltiStatus: (ewayNumber, consignmentId) =>
    `${BASE_URL}/odin/v2/consignments/check-bilti-status?ewayNumber=${ewayNumber}&consignmentId=${consignmentId}`,
  getChatSession: (tripId) => `${BASE_URL}/odin/chat/session/${tripId}`,
  getChatMessages: (tripId) => `${BASE_URL}/odin/chat/messages/${tripId}`,
  getAiRemark: `${BASE_URL}/odin/v1/ai/remark`,
  supportAgentsList: `${BASE_URL}/odin/support-agent/v1/`,
  supportAgentAdd: `${BASE_URL}/odin/support-agent/v1/add`,
  supportAgentTeams: `${BASE_URL}/odin/support-agent/v1/teams`,
  supportAgentUpdate: `${BASE_URL}/odin/support-agent/v1/update`,
};
